webpackJsonp([30],{

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(187);

var $ = __webpack_require__(0);

$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    $('.o-static-heading__bg').each(function () {
        var $element = $(this);
        $element.css({
            width: 100 + scroll / 8 + "%"
        });
    });
});

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[186]);


// WEBPACK FOOTER //
// o-static-heading.js